import React from 'react';
import { Transition as TransitionItem } from 'react-transition-group';
import { Motion } from './motion';
import { func } from '../../../util';

export function Transition(config, extraWrap = false) {
  return (ComposedComponent) => {
    function Wrapped(props) {
      const onEnter = (node) => {
        if (config.enter) {
          config.enter(node, func.noop);
        }
      };

      const onLeave = (node) => {
        if (config.exit) {
          config.exit(node, () => {
            node.style.display = 'none';
          });
        }
      };

      const timeout = config.timeout === undefined ? 5000 : config.timeout;
      const child = extraWrap ? <div><ComposedComponent {...props} /></div> : <ComposedComponent {...props} />

      return (
        <TransitionItem
          timeout={timeout}
          in={props.in}
          mountOnEnter={true}
          unmountOnExit={true}
          onEnter={onEnter}
          onExit={onLeave}
        >
          { child }
        </TransitionItem>
      );
    }

    Wrapped.displayName = `Transition.${ComposedComponent.displayName || 'anonymous'}`;
    return Wrapped;
  };
}
